import { upload, post, put, destroy } from 'app/shared/utils/fetchr';
import routes, { pathJoin } from 'app/shared/utils/routes';

// Models
import {
  FullCaseResponse,
  ShortCaseResponse,
} from 'app/modules/cases/responses';
import { BulkFileExportPayload } from 'app/modules/fileExportsOld/models';
import { UploadFilesPayload } from 'app/modules/uploads/models';
import { GoogleDriveDoc } from 'app/modules/attachments/models';

// Actions
import { removeNullKeys } from 'app/shared/utils/apiUtils';
import { CaseEditPayload, CreateCasePayload } from 'app/modules/cases/requests';
import { DeleteAlertCaseAttachmentResponse } from 'app/modules/attachments/responses';

export const createCase = (payload: CreateCasePayload) => {
  return post<ShortCaseResponse>(routes.patronus.casesCreate, payload);
};

export const updateCase = (payload: CaseEditPayload) => {
  const { id, ...details } = payload;
  return put<FullCaseResponse>(
    routes.patronus.casesEditId.replace(':id', String(id)),
    details,
  );
};

export const addDocumentsToCase = (
  caseId: number,
  documents: GoogleDriveDoc[],
) => {
  // remove null keys
  const docs = documents.map((doc) => removeNullKeys(doc));

  return post(pathJoin('/v1/cases', caseId, '/attachments', 'add'), {
    docs,
  });
};

export const deleteDocumentFromCase = (caseId: number, docId: number) => {
  const formattedPath = routes.patronus.casesIdAttachmentsAttachmentId
    .replace(':id', String(caseId))
    .replace(':attachmentId', String(docId));
  return destroy<DeleteAlertCaseAttachmentResponse>(formattedPath);
};

export const addFiles = (payload: UploadFilesPayload) => {
  const formData = new FormData();

  payload.files?.forEach((S3File, index) => {
    formData.append(`file${index}`, S3File);
  });

  return upload(
    routes.patronus.casesIdAddFiles.replace(':id', payload.id),
    formData,
  );
};

export const sendBulkCasesXlsxRequest = (payload: BulkFileExportPayload) => {
  return post(routes.patronus.casesBulkXlsx, payload);
};
